import { MuiTooltip as MuiTooltipBase } from '@dentalux/ui-library-core/themes';
const MuiTooltip = {
  defaultProps: {
    enterTouchDelay: 0
  },
  ...MuiTooltipBase
};
export default MuiTooltip;